export const transformNumberToLocaleString = (value: number): string => {
  // replace all comma (,) with a blank character
  // use en-GB as a language for all browsers
  return value?.toLocaleString('en-GB').replace(/,/g, ' ');
};
